const GRAPH_COLORS = [
    '#00bfdc', '#5100dc', '#ff5f77', '#b758cb', '#00c8ff', '#00fa58', '#ffc200',
    '#ff002d', '#002a48', '#68748c', '#8f8f8f',
];

module.exports = GRAPH_COLORS;
